import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { NotificationData } from '../interfaces/NotificationData';
import {
  addNotificationItem,
  removeNotificationItem,
} from '../../features/state/StateNotification-slice';

export const useNotificationHelper = () => {
  const notification: NotificationData = useAppSelector((state) => state.notification.value);
  const dispatch = useAppDispatch();

  const addNotification = (notification: NotificationData) => {
    dispatch(addNotificationItem(notification));
    setTimeout(() => {
      dispatch(removeNotificationItem());
    }, 5000);
};

  const removeNotification = () => {
    dispatch(removeNotificationItem());
  };

  return {
    notification,
    addNotification,
    removeNotification,
  };
};
